import { render, staticRenderFns } from "./CotizrTable.vue?vue&type=template&id=322894e6&scoped=true&"
import script from "./CotizrTable.vue?vue&type=script&lang=js&"
export * from "./CotizrTable.vue?vue&type=script&lang=js&"
import style0 from "./CotizrTable.vue?vue&type=style&index=0&id=322894e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322894e6",
  null
  
)

export default component.exports